import { render, staticRenderFns } from "./WBSelectField.vue?vue&type=template&id=8fcdb4a8&scoped=true&"
import script from "./WBSelectField.vue?vue&type=script&lang=js&"
export * from "./WBSelectField.vue?vue&type=script&lang=js&"
import style0 from "./WBSelectField.vue?vue&type=style&index=0&id=8fcdb4a8&prod&lang=scss&"
import style1 from "./WBSelectField.vue?vue&type=style&index=1&id=8fcdb4a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcdb4a8",
  null
  
)

export default component.exports